<!--
 * @Author: Gaho
 * @Date: 2024-01-31 11:54:01
 * @LastEditors: Merlin
 * @LastEditTime: 2025-07-08 17:27:49
 * @Description: 游戏卡片
-->
<template>
    <div class="game-card"
        :data-game-name="data.name"
    >
        <div class="game-card-link card"
            @click="() => handleEnterGame(data)"
        >
            <!-- 游戏卡片图片 start -->
            <div class="game-card-img">
                <q-img ref="gameCover"
                    :src="getGameCoverSrc(data.name)"
                    :alt="$t(data.title)"
                >
                    <template #loading>
                        <SkeletonLoader type="flow" ></SkeletonLoader>
                    </template>
                </q-img>
            </div>
            <!-- 游戏卡片图片 end -->
            <!-- 游戏卡片信息 start -->
            <div class="game-card-badges">
                <!-- jackpot 展示信息 -->
                <ClientOnly>
                    <div v-if="data.status == 2" class="card-badge test-badge">
                        <img class="w-[15px] h-[15px] mr-[3px]" src="@/assets/imgs/lightning.png" alt="lightning">
                        <div>{{ $t('gameTitle.Test') }}</div>
                    </div>
                    <div @click.stop
                        class="card-badge card-badge-bottom"
                        v-else-if="globalStore?.jackpotSum[data?.name] >= 0 && data.status != 2"
                    >
                        <Popper hover arrow placement="top" :style="oPopperStyle" class="w-full">
                            <div class="text-center">
                                {{ handleExchangeRate(globalStore.jackpotSum[data.name])?.toFixed(0) }}
                                {{ currentCurrency.toLocaleUpperCase() }}
                            </div>

                            <template #content>
                                <span class="!text-[10px] font-[400]">
                                    {{ $t('gameTitle.JackpotAmount') }}
                                </span>
                            </template>
                        </Popper>
                    </div>
     
                </ClientOnly>
            </div>
            <!-- 游戏卡片信息 end -->
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import Popper from "vue3-popper";
// stores
import useGlobalStore from '@/stores/global';
import useSettingsStore from '@/stores/settings';
// functions
import { getImageUrl, getNewImageUrl } from '../ts/index';


export default defineComponent({
    name: 'gameCard',
    components: {
        Popper,
    },
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
        index: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            $t: useI18n().t,
            globalStore: useGlobalStore(),
        };
    },
    computed: {
        currentCurrency() {
            return useSettingsStore().pickedCurrency || 'btc';
        },
    },
    mounted() {
        // const imgs = [this.$refs.gameCover];
        // 异步观察视口交叉状态（停用，以使用低版本浏览器，已经直接为封面设定路径） 
        // handleObserve(imgs, 'lazyload-image');
    },
    methods: {
        /**
         * 点击跳转到对应的游戏页面
         * @param data {Object} 游戏卡片数据
         */
        handleEnterGame(data) {
            const sGame = (
                data.name.toLocaleLowerCase()
            );
            const pageUrl = getLocalPath(`/casino/${sGame}Game`);
            navigateTo(pageUrl);
        },
        /**
         * 获取并格式化游戏图片地址
         * @param game { string } 游戏名称
         */
        getGameCoverSrc(game: string) {
            try {
                const src = (
                    getNewImageUrl(game) || getImageUrl(game)
                );
                return src;
            } catch (error) {
                console.error(`game ${game} no cover, error\n`, error); 
            }
        },
    },
});
</script>

<style lang="scss" scoped>
.game-card {
    border-radius: 20px;
    container-type: inline-size;
    overflow: hidden;
    .game-card-link {
        border-radius: 14px;
        box-shadow: 0 0 0 transparent, 0 0 0 transparent;
        cursor: pointer;
        font-feature-settings: 'tnum' on, 'lnum' on;
        height: 100%;
        letter-spacing: -0.02em;
        overflow: hidden;
        text-decoration: none;
        width: 100%;
        z-index: 0;
        content-visibility: auto;
        contain-intrinsic-size: 160px 215px;
        transition: box-shadow 0.1s ease-in-out, transform 0.1s ease-in-out;
        display: flex;

        .game-card-img {
            background: linear-gradient(150.15deg,
                    rgba(34, 131, 246, 0.147) 27.17%,
                    rgba(34, 131, 246, 0.084) 46.76%,
                    rgba(34, 131, 246, 0) 61.36%),
                #263041;
            width: 100%;
            display: block;
            height: 100%;
            pointer-events: none;
            transition: filter 0.1s ease-in-out, transform 0.1s ease-in-out;

            img {
                opacity: 1;
                height: 100%;
                width: 100%;
                border-radius: 14px;
                object-fit: cover;
            }

            img[src=""],
            img:not([src]) {
                // ↓ 全透明的图，防止出现死图样式 
                content: linear-gradient(#0000, #0000);
            }

            :deep() {
                .q-img__container {
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                }
            }
        }

        .game-card-badges {
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: space-between;
            // padding: 11px;
            width: 100%;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.06em;
            line-height: 16px;
            margin-bottom: 1rem;
            text-transform: uppercase;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;

            .card-badge {
                align-items: center;
                border-radius: 300px;
                color: #fff;
                display: flex;
                font-size: 11px;
                font-weight: 700;
                height: 25px;
                justify-content: center;
                letter-spacing: 0.06em;
                line-height: 16px;
                margin-bottom: 0;
                padding: 4px 0;
                text-transform: uppercase;
                white-space: nowrap;
                width: min-content;
            }

            .card-badge-top {
                display: flex;

                .top {
                    background-color: #ed1d49;
                    box-shadow: 0 3px 18px rgba(151, 36, 0, 0.5);
                }

                .hot {
                    box-shadow: 0 3px 18px rgba(151, 36, 0, 0.5);
                    background-color: #ff5f2d;
                }

                .drops-and-win {
                    backdrop-filter: blur(10px);
                    background: rgba(209, 209, 209, 0.3);
                    border: 1px solid #fff3;
                    box-shadow: 0 4px 8px rgba(0, 10, 60, 0.6);
                    height: 40px;
                    margin-left: auto;
                    position: relative;
                    width: 40px;

                    span {
                        font-size: 44px;
                        height: 48px;
                        left: 0;
                        position: absolute;
                        top: -10px;
                        width: 39px;
                        background-image: url(@/assets/imgs/home/drops-and-wins.svg);
                        background-position: 50%;
                        background-repeat: no-repeat;
                        background-size: contain;
                        display: block;
                    }
                }
            }

            .card-badge-bottom,.test-badge  {
                background: #ed8e00;
                box-shadow: 0 3px 18px 0 rgba(216, 130, 0, 0.5);
                color: #fff;
                bottom: 0;
                position: absolute;
                left: 0;
                border-radius: 0;
                letter-spacing: 0;
                width: 100%;
                height: 30px;
            }
            .test-badge {
                background: radial-gradient(85.16% 313.7% at 41.04% 18.18%, #FC66FF 0%, #CC0613 100%);
                box-shadow: 0px -3px 5px 0px #A2000080 inset;
                border-radius: 15px;
            }
        }
    }

    @media (max-width: 555px) {
        overflow: hidden;

        .game-card-link {
            contain-intrinsic-size: 131px 171px;
            min-width: var(--min-width);
        }
    }
}

.currency {
    cursor: pointer;
    align-items: center;
    display: inline-flex;
    flex-shrink: 0;
    color: #fff;

    .currency-icon {
        margin-right: 6px;
    }

    .balance {
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        font-weight: 600;
    }
}
:deep(.popper){
    padding: 8px 6px;
    max-width: 100%;
    padding: 0px;
    span{
        display: inline-block;
        width: 100%;
        padding: 6px 4px;
    }
}
</style>